import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { HelperService, HTTPService, DateService } from 'app/services';
import { config } from 'app/constants';
import { datetimeFormat } from 'app/constants/date-time-format';

interface StockItem {
  creationDate: string;
  quantity: number;
  code: string;
  price: number;
  cost: number;
  coreCost: number;
  orderId?: string; // Optional if not always present
}

@Component({
  selector: 'app-qty-on-estimate-list-modal',
  templateUrl: './qty-on-estimate-list-modal.component.html',
  styleUrls: ['./qty-on-estimate-list-modal.component.scss'],
})
export class QtyOnEstimateListModalComponent implements OnInit {
  itemId: string = '';
  itemName: string = '';
  stockList: StockItem[] = []; // Typed array
  salesCol: { field: string; header: string; className: string }[] = [];
  isLoading: boolean = true;
  tableConfig = {
    skip: 0,
    limit: config.pageTwentySize,
  };
  totalRecords = 0;

  constructor(
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private httpService: HTTPService,
    private helperService: HelperService,
    private dateService: DateService
  ) { }

  async ngOnInit(): Promise<void> {
    const { itemId, name } = this.dynamicDialogConfig.data;
    this.salesCol = [
      { field: 'date', header: 'Date Added', className: 'sup-date' },
      { field: 'quantity', header: 'Qty', className: 'quantity' },
      { field: 'roNumber', header: 'RO #', className: 'roNumber' },
      { field: 'price', header: 'Price', className: 'price' },
      { field: 'cost', header: 'Cost', className: 'cost' },
      { field: 'core', header: 'Core', className: 'core' },
    ];

    if (itemId) {
      this.itemId = itemId;
      this.itemName = name;
      await this.getInvStockDetails();
    }
  }

  async getInvStockDetails(): Promise<void> {
    const conf = {
      skip: this.tableConfig.skip,
      limit: this.tableConfig.limit,
    };

    try {
      const response: any = await this.httpService.getInvStocksEstimateHistory(this.itemId, conf);
      if (response?.records?.length > 0 && Object.keys(response.records[0]).length > 0) {
        this.stockList = response.records;
      } else {
        this.stockList = [];
      }

      if(this.stockList?.length) {
        this.stockList.forEach((item: any) => {
          if(item?.creationDate) {
            const dateTime = this.dateService.getCurrentDateTimeTz(new Date(item.creationDate).getTime());
            item.creationDate = this.dateService.formatDate(dateTime, datetimeFormat.mmmdyyyy);
          }
        });
      }

      this.totalRecords = response?.metaData?.totalRecords || 0;
    } catch (error) {
      console.error('Error fetching inventory stock details:', error);
    } finally {
      this.isLoading = false;
    }
  }

  paginate(event: any): void {
    if (event) {
      this.tableConfig.skip = event.page * this.tableConfig.limit;
      this.getInvStockDetails();
    }
  }

  handleClose(isSuccess: boolean = false): void {
    this.dynamicDialogRef.close({ isSuccess });
  }

  openRO(roData: StockItem): void {
    if (!roData.orderId) return;
    this.helperService.openPageInNewExistingTab(`/estimate/${roData.orderId}`, roData.orderId);
  }
}
